// packages/shared/src/schemas/invoice.ts
import { z } from 'zod'

export const InvoiceStatusEnum = z.enum(['unpaid', 'paid', 'overdue', 'void'])

export const InvoiceSchema = z.object({
  id: z.string(),
  invoiceNumber: z.string(),          // BC-INV-2026-0001
  orderId: z.string(),
  customerPhone: z.string(),
  customerName: z.string(),
  customerEmail: z.string().nullable(),

  status: InvoiceStatusEnum,

  subtotal: z.number().min(0),
  discountAmount: z.number().min(0),
  shippingAmount: z.number().min(0),
  taxCgst: z.number().min(0),         // 3% CGST
  taxSgst: z.number().min(0),         // 3% SGST
  total: z.number().min(0),

  gstNumber: z.string().nullable(),   // customer GST (B2B)
  hsnCode: z.string(),                // default '7113' for jewelry

  issuedAt: z.string(),
  dueAt: z.string().nullable(),
  paidAt: z.string().nullable(),

  voidReason: z.string().nullable(),
  pdfUrl: z.string().nullable(),

  createdAt: z.string(),
})

export const VoidInvoiceInput = z.object({
  reason: z.string().min(10, 'Reason must be at least 10 characters').max(500),
})

export const MarkPaidInput = z.object({
  paymentReference: z.string().min(1, 'Payment reference required').max(200),
  paidAt: z.string().optional(),
})

export const InvoiceListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
  status: InvoiceStatusEnum.optional(),
  search: z.string().trim().optional(),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  sortBy: z.enum(['issued_at', 'total', 'invoice_number']).default('issued_at'),
  sortDir: z.enum(['asc', 'desc']).default('desc'),
})

export type Invoice = z.infer<typeof InvoiceSchema>
export type VoidInvoiceInput = z.infer<typeof VoidInvoiceInput>
export type MarkPaidInput = z.infer<typeof MarkPaidInput>
